import React from 'react';
import Button from '../../../../../components/ui/button';
import { FiDownload } from 'react-icons/fi';
import { formatCurrency, formatDate } from '../../../shared/constants';

const ExportButton = ({ expenses, month, clientName }) => {
	const exportToCSV = () => {
		// Create CSV content
		const headers = ['Name', 'Category', 'Date', 'Notes', 'Amount'];
		const rows = expenses.map((expense) => [
			expense.name,
			expense.category,
			expense.date,
			expense.notes || '',
			expense.amount,
		]);

		const csvContent = [
			headers.join(','),
			...rows.map((row) =>
				row
					.map((cell) => `"${String(cell).replace(/"/g, '""')}"`)
					.join(',')
			),
		].join('\n');

		// Create download link
		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const link = document.createElement('a');
		const url = URL.createObjectURL(blob);
		link.setAttribute('href', url);
		link.setAttribute(
			'download',
			`expenses_${month.replace(' ', '_')}.csv`
		);
		link.style.visibility = 'hidden';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<Button
			onClick={exportToCSV}
			variant='outline'
			size='md'
			className='flex items-center gap-2'>
			<FiDownload className='h-4 w-4' />
			Export to CSV
		</Button>
	);
};

export default ExportButton;
